'use client';

import styles from './IconGrid.module.css';

// icons
import { 
    Zap, Typo_or_bug, Speedometer, Typing, 
    Boost, Filter, Sliders_vertical, Fields,
    Discovery, User_privacy, Update, Nested_object,
    Sort_descending, Flag, Internet_browser, Mcp,
    Pattern_recognition, Linear, Scales, Hybrid_search
} from "@indxsearch/pixl";
import FeatureIcon from '../components/FeatureIcon';

export default function IconGrid() {
    const features = [
      { icon: <Zap />, label: "Instant response time" },
      { icon: <Speedometer />, label: "Rapid indexing" },
      { icon: <Typo_or_bug />, label: "Unmatched typo tolerance" },
      { icon: <Typing />, label: "Search as you type" },
      { icon: <Boost />, label: "Boosting logic" },
      { icon: <Filter />, label: "Advanced filters" },
      { icon: <Sliders_vertical />, label: "Faceted navigation" },
      { icon: <Fields />, label: "Field based index" },
      { icon: <Discovery />, label: "Relevancy Ranking" },
      { icon: <User_privacy />, label: "GDPR compliant" },
      { icon: <Update />, label: "Real-time updates" },
      { icon: <Nested_object />, label: "Nested JSON support" },
      { icon: <Sort_descending />, label: "Smart result sorting" },
      { icon: <Flag />, label: "Supports all languages" },
      { icon: <Internet_browser />, label: "Server with admin UI" },
      { icon: <Mcp />, label: "MCP server" },
      { icon: <Pattern_recognition />, label: "Pattern Recognition" },
      { icon: <Linear />, label: "Linear performance scaling" },
      { icon: <Scales />, label: "Field weights" },
      { icon: <Hybrid_search />, label: "Hybrid Search" },
    ];

    return (
      <div className={styles.wrapper}>
        <div className={styles.inside}>
          {features.map(({ icon, label }, index) => (
            <FeatureIcon key={index} icon={icon} label={label} />
          ))}
        </div>
      </div>
    );
}
